module.exports = {
    DEVICES: Object.freeze({
        ios: 'IOS',
        android: 'Android',
        androidChrome: 'Android Chrome',
        desktop: 'Браузер',
        iphone: 'IPhone',
        ipod: 'IPod',
        ipad: 'IPad',
        cordova: 'Cordova',
        capacitor: 'Capacitor',
        windows: 'Windows',
        macos: 'Mac os',
    })
}
